export const SakuraMark = ({ size = 28, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        className={className}
        aria-hidden="true"
    >
        <rect width="64" height="64" rx="16" fill="#F0E2E4" />
        <path
            d="M32 54c0 0-1-10-3-15"
            stroke="#8A7D7A"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <g fill="#CF8696">
            {[0, 72, 144, 216, 288].map((r) => (
                <ellipse
                    key={r}
                    cx="32"
                    cy="25"
                    rx="5.5"
                    ry="9"
                    transform={`rotate(${r} 32 32)`}
                />
            ))}
        </g>
        <circle cx="32" cy="32" r="3.2" fill="#5E3444" />
        <g fill="#D8B0B8">
            <ellipse cx="14" cy="44" rx="4.2" ry="7" transform="rotate(-32 14 44)" />
            <ellipse cx="50" cy="42" rx="4.2" ry="7" transform="rotate(28 50 42)" />
        </g>
    </svg>
);

export default SakuraMark;
